/**
 * 排出事業者
 */
import Vue from 'vue'
import * as httpConst from '../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/emission_locations`

const getDefaultState = () => {
  return {
  }
}
const emission_location = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
  },
  actions: {
    /**
     *
     * @param commit
     * @param conditions { Object }
     * @return {Promise<unknown>}
     */
    index ({ commit }, { conditions }) {
      return new Promise((resolve) => {
        Vue.$http.get(`${API_PATH}.csv`, { params: conditions }).then(data => {
          resolve(data)
        })
      })
    },
  },
  mutations: {},
}

export default emission_location

